import dayjs from "dayjs";
import { DEFAULT_DATE_FORMAT } from "../configs/dateConfig";

// Match the local time shown by the delivery editor; never shift display to UTC.
export const formatDeliveryDate = (value?: string | Date | null): string => {
    if (!value) return "";
    const date = dayjs(value);
    return date.isValid() ? date.format(`${DEFAULT_DATE_FORMAT} HH:mm`) : "";
};
